import React, {useContext} from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Pagination from './Pagination';
import AccommodationTeaser from '../Common/AccommodationTeaser';
import AccommodationTeaserSkeleton from '../Common/AccommodationTeaserSkeleton';
import {AppContext} from '../../contexts/AppContext';
import './List.css';

const List = () => {

    const {
        isLoading,
        filteredResults,
        currentPage,
        itemsPerPage,
        handlePageChange
    } = useContext(AppContext);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentResults = filteredResults.slice(startIndex, startIndex + itemsPerPage);

    const totalPages = Math.ceil(filteredResults.length / itemsPerPage);

    return (
        <>
            <TransitionGroup className="accommodation-overview--teasers">
                {isLoading
                    ? Array.from({length: 8}).map((_, index) => (
                        <CSSTransition key={`skeleton-${index}`} timeout={500} classNames="skeleton-fade">
                            <AccommodationTeaserSkeleton/>
                        </CSSTransition>
                    ))
                    : currentResults.map((item) => (
                        <CSSTransition key={`accommodation-${item.accommodationId}`} timeout={500} classNames="accommodation-fade">
                            <AccommodationTeaser data={item}/>
                        </CSSTransition>
                    ))
                }
            </TransitionGroup>
            {!isLoading && totalPages > 1 && (
                <div className="accommodation-overview--teasers-bottom">
                    <hr/>
                    <nav aria-label="Pagination" className="pagination-nav pagination-nav--bottom">
                        <Pagination totalPages={totalPages} currentPage={currentPage} maxPagesToShow={6} onPageChange={handlePageChange}/>
                    </nav>
                </div>
            )}
        </>
    );
}

export default List;